<template>
  <span style="width: auto">
    <RsIcon
      :id="tooltipID"
      icon="question-circle"
      class="question-icon"
      tabindex="0"
    />
    <RsTooltip
      :target="tooltipID"
      :position="tooltipPosition"
      :delay="{ show: tooltipDelayMilliSec }"
      :triggers="triggers.join(' ')"
    ><slot style="color: white" />
    </RsTooltip>
  </span>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'RsHelpTooltip',

  props: {
    size: {
      type: String as PropType<'md'>,
      default: 'md',
    },

    tooltipPosition: {
      type: String as PropType<'left' | 'right' | 'auto' | 'top'>,
      default: 'auto',
    },

    triggers: {
      type: Array as PropType<('hover' | 'click' | 'focus' | 'blur')[]>,
      default: () => [],
    },

    tooltipDelayMilliSec: {
      type: Number,
      default: 200,
    },
  },

  data() {
    return {
      tooltipID: `helperTooltip-${Math.random()}`,
    };
  },
});
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
.question-icon{
  font-weight: bold;
  color: $secondary-color;
}
</style>
